import React, { useEffect, useState } from 'react';
import {
    Box, Button, Checkbox, FormControlLabel, Stack, TextField, Typography, Chip, IconButton
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Close';

const NoticeForm = () => {
    const navigate = useNavigate();
    const { id } = useParams(); // 수정 모드 여부 판단용

    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [author, setAuthor] = useState('');
    const [isImportant, setIsImportant] = useState(false);
    const [tags, setTags] = useState<string[]>([]);
    const [tagInput, setTagInput] = useState('');
    const [locale, setLocale] = useState('');

    useEffect(() => {
        if (id) {
            axios.get(`https://roomi.co.kr/api/admin/notices/${id}`)
                .then((res) => {
                    const data = res.data;
                    setTitle(data.title);
                    setContent(data.content);
                    setAuthor(data.author);
                    setIsImportant(data.is_important);
                    setLocale(data.locale || '');
                    try {
                        setTags(data.tags ? JSON.parse(data.tags) : []);
                    } catch {
                        setTags([]);
                    }
                });
        }
    }, [id]);

    const handleSubmit = async () => {
        const payload = {
            title,
            content,
            author,
            is_important: isImportant,
            tags,
            locale,
        };

        try {
            if (id) {
                await axios.patch(`https://roomi.co.kr/api/admin/notices/${id}`, payload);
                alert('공지사항이 수정되었습니다.');
            } else {
                await axios.post(`https://roomi.co.kr/api/admin/notices`, payload);
                alert('공지사항이 등록되었습니다.');
            }
            navigate('/admin/notices');
        } catch (e: any) {
            alert('처리 중 오류가 발생했습니다.');
        }
    };

    const handleAddTag = () => {
        const newTag = tagInput.trim();
        if (newTag && !tags.includes(newTag)) {
            setTags([...tags, newTag]);
        }
        setTagInput('');
    };

    const handleDeleteTag = (tagToDelete: string) => {
        setTags(tags.filter((tag) => tag !== tagToDelete));
    };

    return (
        <Box maxWidth="md" mx="auto" mt={4}>
            <Typography variant="h5" mb={3}>{id ? '공지사항 수정' : '공지사항 등록'}</Typography>

            <Stack spacing={2}>
                <TextField
                    label="제목"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    fullWidth
                />

                <TextField
                    label="내용"
                    value={content}
                    onChange={(e) => setContent(e.target.value)}
                    fullWidth
                    multiline
                    rows={6}
                />

                <TextField
                    label="작성자"
                    value={author}
                    onChange={(e) => setAuthor(e.target.value)}
                    fullWidth
                />

                <FormControlLabel
                    control={<Checkbox checked={isImportant} onChange={(e) => setIsImportant(e.target.checked)} />}
                    label="중요 공지"
                />

                <Box>
                    <TextField
                        label="태그 추가"
                        value={tagInput}
                        onChange={(e) => setTagInput(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && handleAddTag()}
                    />
                    <Box mt={1} display="flex" gap={1} flexWrap="wrap">
                        {tags.map((tag) => (
                            <Chip
                                key={tag}
                                label={tag}
                                onDelete={() => handleDeleteTag(tag)}
                                deleteIcon={<DeleteIcon />}
                            />
                        ))}
                    </Box>
                </Box>

                <TextField
                    label="언어(locale)"
                    value={locale}
                    onChange={(e) => setLocale(e.target.value)}
                    fullWidth
                />

                <Button variant="contained" color="primary" onClick={handleSubmit}>
                    {id ? '수정하기' : '등록하기'}
                </Button>
            </Stack>
        </Box>
    );
};

export default NoticeForm;